<template>
  <div class="flex flex-col divide-y flex-grow">
    <div v-if="!partner && $wait.is(`fetch.partners.${partnerId}`)" class="p-2 flex justify-center">
      <LoadingSpinner />
    </div>
    <template v-else>
      <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
        <RouterTabs :tabs="tabs"/>
        <div class="flex-shrink-0 flex items-center">
          <template v-if="$route.name === 'partners.edit.main'">
            <div class="flex flex-col items-end">
              <a :href="formUrl" target="_blank">
                <b class="text-primary text-12px">{{ formUrl }}</b>
              </a>
            </div>
          </template>
          <button
            v-else-if="$route.name === 'partners.edit.orders'"
            class="btn btn-sm btn-primary font-normal"
            @click="onOrdersExportClick"
          >
            Экспорт в Excel
          </button>
        </div>
      </div>
      <router-view />
    </template>
  </div>
</template>

<script type="text/javascript">
import RouterTabs from '@/components/RouterTabs.vue';
import { mapActions, mapGetters } from 'vuex';
import { exportOrdersById } from '@/api/partners';
import { downloadBinaryResponse } from '@/utils';
import LoadingSpinner from '@/components/Loading/LoadingSpinner.vue';

export default {
  name: 'PartnersEditMain',
  components: { RouterTabs, LoadingSpinner },
  data() {
    return {
      tabs: [
        { title: 'Информация', push: { name: 'partners.edit.main' } },
        { title: 'Заказы', push: { name: 'partners.edit.orders' } },
        { title: 'Как это работает', push: { name: 'partners.edit.howItWorks' } },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getPartnerById: 'partners/getPartnerById',
    }),
    partnerId() {
      return this.$route.params.id;
    },
    partner() {
      return this.getPartnerById(this.partnerId);
    },
    formUrl() {
      return `${process.env.VUE_APP_PARTNER_BASE_URL.replace(/\/$/, '')}/?partnerId=${this.partner?.uuid}`;
    },
  },
  methods: {
    ...mapActions({
      fetchPartnerById: 'partners/ACT_FETCH_PARTNER_BY_ID',
    }),
    async onOrdersExportClick() {
      const response = await exportOrdersById(this.partnerId);
      downloadBinaryResponse(response);
    },
  },
  mounted() {
    this.fetchPartnerById(this.partnerId);
  },
};
</script>
